import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import FormattedPrice from '@/components/Base/Formats/FormattedPrice.vue';
export default defineComponent({
    name: 'blue-checkout-product-overview',
    components: { FormattedPrice },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        current_products: 'currentProducts',
        cart_totals: 'cartTotals',
    })), { first_product: function () {
            return this.current_products.length > 0 ? this.current_products[0] : null;
        }, count_total: function () {
            var _a, _b;
            return (_b = (_a = this.cart_totals) === null || _a === void 0 ? void 0 : _a.products) !== null && _b !== void 0 ? _b : 0;
        }, total_costs: function () {
            var _a, _b;
            return (_b = (_a = this.cart_totals) === null || _a === void 0 ? void 0 : _a.brutto_products) !== null && _b !== void 0 ? _b : 0;
        } }),
});
